import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContenedorBoton, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import global_axios from '../../funciones_globales/interaccionapi';
import styled from 'styled-components';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { cargarCatalogosGenericoAsync, generarItemCatalogoSeleccionado } from '../../funciones_globales/catalogos';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import moment from 'moment';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cargar_Proformas } from '../../actions/ventas/act_ven02';
import { cargar_Embalaje } from '../../actions/ventas/act_ven03';
import { cargar_Cliente } from '../../actions/clientes/act_cli01';
import { addItemArray, deleteItemArray }  from '../../funciones_globales/arrays';
import { esNumeroEntero, validarCampoString, validarFechaMomentEnFormatoString, validarFechaTransaccionSeleccionada, validarPermisoAcceso } from '../../funciones_globales/utils';
import { formatearFechaMoment_a_String, formatearNumeroEntero } from '../../funciones_globales/format';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import { LabelForm, LabelCabecera } from '../componentes_generales/componentes_formulario/labels/';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { obtenerSecuencial } from '../../funciones_globales/parametros';

const Columna = styled.td`
  padding: 100px 0 0 0;
  width: 100%;
  margin: 0;
`;

const DivCentrado = styled.div`
  width: ${props => props.porc_ancho?props.porc_ancho:50}%;
  margin: 0 auto;
`;

class FormVen03 extends React.Component{
  
  constructor(props) {
    super(props);
    this.state = {                             
      proformasPend: [],
      detEmbalaje: [], 
      cliente_sel: null,
      bloquear_SelectCliente: false,
      nroCartones: '',
      operacion: 'G',
      servicioEmbalajeCobrado: 'N',
      fechaEmbalaje: null,
      secuencialEmbalaje: '',
      columnsDefGridProforma: [ {
          header: "No.",
          field: "Nro",
          width: 35,
          type: "string"
        },
        { header: "Proforma",
          field: "Proforma",
          width: 71,
          type: "string"
        },
        { header: "Fecha",
          field: "Fecha",
          width: 125,
          type: "string"
        },  
        {
          header: "Pedido",
          field: "PedidoMovil",
          width: 60,
          type: "string"
        },      
        { header: "Items",
          field: "NroItems",
          width: 50,
          type: "num_entero"
        },
        { header: "Estado",
          field: "Estado",
          width: 80,
          type: "string"
        }
      ],
      columnsDefGridDetEmbalaje: [ {
        header: "No.",
        field: "Nro",
        width: 35,
        type: "string"
      },
      { header: "Proforma",
        field: "Proforma",
        width: 80,
        type: "string"
      },        
      { header: "Fecha",
        field: "Fecha",
        width: 130,
        type: "string"
      },
      {
        header: "Pedido",
        field: "PedidoMovil",
        width: 65,
        type: "string"
      },
      { header: "Items",
        field: "NroItems",
        width: 55,
        type: "num_entero"
      },
      { header: "Estado",
        field: "Estado",
        width: 147,
        type: "string"
      }
    ],
    };
    this.gridDetEmbalajeOptions = {
      enableColResize: true,
      rowSelection: 'single',
      rowDeselection: 'true',
      getRowStyle: (params) =>{
        if (params.data.CobroEmbalaje === 'S') {
          return {'background-color': '#FAFAD2'}
        }
        return null;
      }
    };
    this.gridProformasOptions = {
      enableColResize: true,
      rowSelection: 'single',
      rowDeselection: 'true'
    };
    this.onGridDetEmbalajeReady = this.onGridDetEmbalajeReady.bind(this);
    this.onGridProformasReady = this.onGridProformasReady.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.getOptions_Clientes = this.getOptions_Clientes.bind(this);
    this.getEmbalajeById = this.getEmbalajeById.bind(this);
    this.obtenerProformas = this.obtenerProformas.bind(this);
    this.guardarEmbalaje = this.guardarEmbalaje.bind(this);
    this.limpiar = this.limpiar.bind(this);
    this.addProformaEmbalaje = this.addProformaEmbalaje.bind(this);
    this.deleteProformaEmbalaje = this.deleteProformaEmbalaje.bind(this);
    this.anularEmbalaje = this.anularEmbalaje.bind(this);
    this.validarModificacion = this.validarModificacion.bind(this);
  }
  
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }

  onGridProformasReady(params) {
    this.apiGridProf = params.api;
    this.columnApiGridProf = params.columnApi;
  }

  onGridDetEmbalajeReady(params) {
    this.apiGridDetEmb = params.api;
    this.columnApiGridDetEmb = params.columnApi;
  }

  getOptions_Clientes(input, callback){
    if (input.toString().length >= 3 ){
      let query = "?tipo=catalogo&cadena_busq=" + input;     
      cargarCatalogosGenericoAsync('/clientes', query, callback)
    }
  }
  
  obtenerProformas(){
    let codCliente = this.state.cliente_sel;
    if (codCliente !== null && codCliente !== undefined){
      this.props.cargar_Cliente(codCliente.value)
      .then(()=>{
        if (this.props.clienteSel.flete === 'S'){
          this.props.cargar_Proformas('PendientesIngresoEmbalaje', 'P', codCliente.value)
          .then(()=>{
            if (this.props.proformas.length===0){
              alert('No existen proformas pendientes de embalaje para el cliente seleccionado.');
            }else{
              this.setState({proformasPend: this.props.proformas});
            }
          });
        }else{
          alert('El cliente seleccionado no está registrado para el cobro de embalaje.');
        }
      });      
    }else{
      alert('Ud. no ha seleccionado el cliente del cual desea consultar las proformas.');     
    }
  }

  getEmbalajeById(){
    let embalaje = this.state.embalajeId;
    if (!validarCampoString(embalaje, 1, 10)){
      alert('Ud. no ha especificado el número de embalaje.');
      return;
    }  
    
    this.props.cargar_Embalaje(embalaje)
    .then(()=>{
      let embalajeSel = this.props.embalajeSel;
      if (embalajeSel === null){
        alert('El embalaje indicado: (' + embalaje + ') no existe.');
        this.limpiar();
      }else{
        let detEmbalajeSel = [];
        embalajeSel.detEmbalaje.forEach((itemDet, indice)=>{
          let itemProforma = {};
          itemProforma.Nro = itemDet.Secuencia;
          itemProforma.Proforma = itemDet.Proforma;          
          itemProforma.Fecha = itemDet.FechaProforma;
          itemProforma.PedidoMovil = itemDet.PedidoMovil;
          itemProforma.NroItems = itemDet.NroItems;
          itemProforma.Estado = itemDet.Estado;
          itemProforma.CobroEmbalaje = itemDet.CobroEmbalaje;
          
          let estadoProforma = itemProforma.Estado.toString().slice(0,1);
          
          if (itemProforma.CobroEmbalaje.toString().trim()==='S' && estadoProforma==='F'){
              this.setState({servicioEmbalajeCobrado: 'S'});
          }          

          detEmbalajeSel.push(itemProforma);
        }); 

        this.setState({ embalajeId: embalajeSel.Movimiento, fechaEmbalaje: moment(embalajeSel.Fecha, 'DD/MM/YYYY'), 
                        nroCartones: embalajeSel.Cartones, detEmbalaje: detEmbalajeSel, operacion: 'M',
                        cliente_sel: generarItemCatalogoSeleccionado(embalajeSel.cli.Cliente, embalajeSel.cli.Nombre),
                        proformasPend: [],  bloquear_SelectCliente: true
                      });
      }
    });
  }

  componentDidMount(){    
    Promise.all([
      obtenerSecuencial('flete'),
      this.props.generar_LogAuditoriaIngresoForm('0403')
    ])
    .then(([secuencialEmbalaje])=>{
      let fechaProceso = getFechaProcesoPorModulo('04');
      this.setState({
        secuencialEmbalaje: (secuencialEmbalaje.codigo-1),
        fechaEmbalaje: moment(fechaProceso, 'DD/MM/YYYY')
      });
    });
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0403');
  }

  limpiar(){
    Promise.all([
      obtenerSecuencial('flete')      
    ])
    .then(([secuencialEmbalaje])=>{
      let fechaProceso = getFechaProcesoPorModulo('04');
      this.setState({ secuencialEmbalaje: (secuencialEmbalaje.codigo-1),
                      servicioEmbalajeCobrado: 'N',
                      proformasPend: [],
                      detEmbalaje: [],
                      cliente_sel: null,
                      embalajeId: '',
                      nroCartones: '',
                      fechaEmbalaje: moment(fechaProceso, 'DD/MM/YYYY'),
                      operacion: 'G',
                      bloquear_SelectCliente: false,
                    });
      });
  }

  addProformaEmbalaje(){
    if (this.state.proformasPend.length===0){
      alert('No existen proformas que se puedan añadir al embalaje.');
      return;
    }

    let filasSeleccionadasProforma = this.apiGridProf.getSelectedRows();
    if (filasSeleccionadasProforma[0]===undefined){
      alert('Debe seleccionar la proforma que desea agregar al embalaje.');
      return;
    }
    
    let existeProforma = false;
    let itemProforma = filasSeleccionadasProforma[0];
    for(let i=0; i<this.state.detEmbalaje.length; i++){
      let itemDetEmb = this.state.detEmbalaje[i];
      if (itemProforma.Proforma === itemDetEmb.Proforma){
        existeProforma = true;
        break;
      }
    }

    if (existeProforma===true){
      alert('Esta proforma ya está en el detalle de embalaje.');
    }else{
      
      let proformaId = itemProforma.Proforma;      
      if(itemProforma.Tipo==='PT'){
        if (itemProforma.ImportEnTransito==='SI'){
          alert('La profoma No. ' + proformaId + ' está relacionada con una importación por liberar. No puede agregar la proforma al embalaje.');
          return;
        }
        if (itemProforma.ImportEnTransito==='AN'){
          alert('La profoma No. ' + proformaId + ' está relacionada con una importación por liberar anulada. No puede agregar la proforma al embalaje.');
          return;
        }
      }

      itemProforma.CobroEmbalaje='';
      this.setState({detEmbalaje: addItemArray(this.state.detEmbalaje, itemProforma), bloquear_SelectCliente: true});

      let indiceElimProf;
      for(indiceElimProf=0; indiceElimProf<this.state.proformasPend.length; indiceElimProf++){
        if (this.state.proformasPend[indiceElimProf].Proforma===itemProforma.Proforma){
          break;
        }
      }

      this.setState({ proformasPend: deleteItemArray(this.state.proformasPend, indiceElimProf) });
    }
  }

  deleteProformaEmbalaje(){
    if (this.state.detEmbalaje.length===0){
      alert('No existen proformas registradas en el embalaje.');
      return;
    }

    let filasSeleccionadasDetEmb = this.apiGridDetEmb.getSelectedRows();
    if (filasSeleccionadasDetEmb[0]===undefined){
      alert('Debe seleccionar la proforma que desea quitar del embalaje.');
      return;
    }
    
    let existeProforma = false;
    let itemProforma = filasSeleccionadasDetEmb[0];    
    let estadoProforma = itemProforma.Estado.toString().slice(0,1);

    if (this.state.operacion==='M'){
      if (estadoProforma === 'F'){
        alert('No se puede quitar esta proforma porque ya está facturada.');
        return;
      }
    }
    
    for(let i=0; i<this.state.proformasPend.length; i++){
      let itemProformaPend = this.state.proformasPend[i];
      if (itemProforma.Proforma === itemProformaPend.Proforma){
        existeProforma = true;
        break;
      }
    }

    if (existeProforma===false){
      this.setState({proformasPend: addItemArray(this.state.proformasPend, itemProforma)});

      let indiceElimProf;
      for(indiceElimProf=0; indiceElimProf<this.state.detEmbalaje.length; indiceElimProf++){
        if (this.state.detEmbalaje[indiceElimProf].Proforma===itemProforma.Proforma){
          break;
        }
      }
      this.setState({ detEmbalaje: deleteItemArray(this.state.detEmbalaje, indiceElimProf) });

      let itemsDetEmb = this.state.detEmbalaje.length - 1;      
      if ( formatearNumeroEntero(itemsDetEmb)===0 && this.state.operacion==='G'){        
        this.setState({bloquear_SelectCliente: false});
      }
    }
  }

  guardarEmbalaje(){
    if (this.state.detEmbalaje.length === 0){
      alert('No existen proformas registradas en el embalaje.');
      return;
    }
    
    let nroCartones = this.state.nroCartones;
    if(!isNaN(nroCartones)===true){
      if(esNumeroEntero(nroCartones)===false || (formatearNumeroEntero(nroCartones)<=0)){
        alert('La cantidad de nro. de cartones es inválida.');
        return;
      }
    }else{
      alert('La cantidad de nro. de cartones es inválida.');
      return;
    }

    let cliente = this.state.cliente_sel;
    if (cliente===null || undefined){
      alert('No ha seleccionado el cliente.');
      return;
    }
    
    let fechaEmbalaje = formatearFechaMoment_a_String(this.state.fechaEmbalaje);
    if (!validarFechaMomentEnFormatoString(fechaEmbalaje)){
      alert('La fecha del embalaje es inválida.');
      return;
    }
        
    let operacion = this.state.operacion.toString();
    let embalajeId = this.state.embalajeId;

    if (operacion==='M'){
      if (!validarCampoString(embalajeId, 1, 10)){
        alert('No ha especificado el embalaje que desea modificar.');
        return;
      }
    }
    
    let proformaMayor=0;
    this.state.detEmbalaje.forEach((proforma)=>{
      if (formatearNumeroEntero(proforma.Proforma)>formatearNumeroEntero(proformaMayor)){
        proformaMayor=formatearNumeroEntero(proforma.Proforma);
      }
    });

    let detEmbalaje = [];
    this.state.detEmbalaje.forEach((proforma)=>{
      if((operacion==='G') || (operacion==='M' && this.state.servicioEmbalajeCobrado==='N')){
        if (formatearNumeroEntero(proforma.Proforma) === formatearNumeroEntero(proformaMayor) ){
          detEmbalaje.push({Proforma: proforma.Proforma, CobroEmbalaje: 'S' });
        }
        else{
          detEmbalaje.push({Proforma: proforma.Proforma, CobroEmbalaje: '' });
        }
      }else{        
        detEmbalaje.push({Proforma: proforma.Proforma, CobroEmbalaje: proforma.CobroEmbalaje });
      }
    });     
    
    let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
    if (!validPermiso.esValido){
      alert(validPermiso.msg);
      return;
    }

    let fechaProceso = getFechaProcesoPorModulo('04');
    if (this.props.permiteCambioFProceso==='S'){
      let validFProceso = validarFechaTransaccionSeleccionada(this.state.fechaProforma, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
      
      if(!validFProceso.esValida){
        alert(validFProceso.msg);
        return;
      }
    }

    let data = { Fecha: fechaEmbalaje, NroCartones: nroCartones, Usuario: getItemDatosSesion('usuario').toString(), Cliente: cliente.value };
    data.detEmbalaje = detEmbalaje;

    global_axios({
      url: (operacion==='G')? '/embalajes': '/embalajes/' + embalajeId,
      method: (operacion==='G')? 'POST': 'PUT',
      data
    })
    .then((response)=>{
      if (this.state.operacion ==='G'){
        alert('El registro de embalaje se procesó correctamente. Embalaje No.: ' + response.data.codEmbalaje);
      }else{
        alert('Se procesó correctamente la actualización del Embalaje No.: ' + response.data.codEmbalaje);
      }
      this.limpiar();
    })
    .catch((error)=>{
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  anularEmbalaje(){
    let operacion = this.state.operacion;
    let embalajeId = this.state.embalajeId;

    if (operacion==='G'){
      alert('No ha seleccionado el embalaje que desea anular.');
      return;
    }

    if (operacion==='M'){
      if (embalajeId === null || embalajeId === undefined || embalajeId === ''){
        alert('No ha especificado el embalaje que desea anular.');
        return;
      }
    }

    let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
    if (!validPermiso.esValido){
      alert(validPermiso.msg);
      return;
    }

    let continuarAnul = window.confirm(`¿Está seguro de anular el Embalaje No.: ${embalajeId} ?`);    
    if (!continuarAnul){
        return;
    }

    global_axios({
      url: '/embalajes/' + embalajeId,
      method: 'DELETE'
    })
    .then((response)=>{
      alert('Se anuló correctamente el embalaje: (' + embalajeId + ')');
      this.limpiar();
    })
    .catch((error)=>{
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  validarModificacion(event){    
    if (this.state.operacion==='M'){
      if (this.state.servicioEmbalajeCobrado.toString()==='S' && event.keyCode !== 9){
        alert('No puede cambiar la cantidad de cartones porque el servicio de embalaje ya fue facturado.');
        event.preventDefault();              
      }
    }
  }

  render(){
    return(
      <ContenedorForm porc_ancho={80}>
        <HeaderForm>
          <TituloForm>Registro de Embalaje</TituloForm>
          <LabelCabecera>Últ. Embalaje: {this.state.secuencialEmbalaje}</LabelCabecera>
        </HeaderForm>
        <CuerpoForm>          
          <Row>
            <div className='col-sm-5'>
              <Row>            
                <ContainerCol className='col-sm-11'>
                  <LabelForm>Cliente:</LabelForm>
                  <ReactSelectAsync disabled={this.state.bloquear_SelectCliente} value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} func_onChange={(value)=>{this.setState({cliente_sel: value, proformasPend:[]})}}/>
                </ContainerCol>                
                <ContainerCol className='col-sm-1'>
                  <ContenedorBoton margen_arriba={20}>
                    <Tooltip placement="right" overlay='Buscar proformas'>
                      <button type='button' className='btn btn-success btn-sm' onClick={this.obtenerProformas}><i className='fa fa-search'></i></button>
                    </Tooltip>
                  </ContenedorBoton>
                </ContainerCol>
              </Row>                                    
              <Row>
                <ContainerCol className='col-sm-12'>
                  <AgGridRender altura='400px' data={this.state.proformasPend} columnas={this.state.columnsDefGridProforma}
                  gridOptions={this.gridProformasOptions} onGridReady={this.onGridProformasReady}/>                  
                </ContainerCol>
              </Row>
            </div>
            <div className='col-sm-1'>
              <table>
                <tbody>
                  <tr>
                    <Columna><DivCentrado porc_ancho={25}><button type='button' className='btn btn-default btn-sm' onClick={this.addProformaEmbalaje}><i className='fa fa-caret-right fa-lg'/></button></DivCentrado></Columna>
                  </tr>
                  <tr>
                    <Columna><DivCentrado porc_ancho={25}><button type='button' className='btn btn-default btn-sm' onClick={this.deleteProformaEmbalaje}><i className='fa fa-caret-left fa-lg'/></button></DivCentrado></Columna>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='col-sm-6'>
              <Row>
                <ContainerCol className='col-sm-4'>
                  <LabelForm>Embalaje:</LabelForm>
                  <InputSearch tipoInput='text' nombre='embalajeId' placeholder='Cód. Embalaje' valor={this.state.embalajeId} func_CambiarValor={this.handleInputChange} func_BuscarValor={this.getEmbalajeById}/>                  
                </ContainerCol>
                <ContainerCol className='col-sm-4'>
                  <LabelForm>Fecha:</LabelForm>
                  <PickerFecha fechaSeleccionada={this.state.fechaEmbalaje} func_onChange={(fecha)=>{this.setState({fechaEmbalaje: fecha})}}
                    disabled={!(this.props.permiteCambioFProceso==='S')}/>
                </ContainerCol>
                <ContainerCol className='col-sm-4'>
                  <LabelForm>Nro. Cartones:</LabelForm>
                  <InputText autoComplete='off' name='nroCartones' value={this.state.nroCartones} type="number" className='form-control input-sm' placeholder='Nro. Cartones' onChange={this.handleInputChange} onKeyDown={(event)=> {this.validarModificacion(event)}}/>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-12'>
                  <AgGridRender altura='400px' data={this.state.detEmbalaje} columnas={this.state.columnsDefGridDetEmbalaje}
                  gridOptions={this.gridDetEmbalajeOptions} onGridReady={this.onGridDetEmbalajeReady}/>
                </ContainerCol>
              </Row>
            </div>
          </Row>
          <Row>
            <div className='col-md-12'>
              <div className='btn-group pull-right'>
                <button type='button' className='btn btn-primary btn-sm' onClick={this.guardarEmbalaje}><i className='fa fa-floppy-o fa-lg'/>{this.state.operacion==='G'?' Guardar':' Modificar'}</button>
                <button type='button' className='btn btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                <button type='button' className='btn btn-danger btn-sm' onClick={this.anularEmbalaje}><i className='fa fa-window-close fa-lg'/> Anular</button>
              </div>
            </div>                  
          </Row>    
        </CuerpoForm>
      </ContenedorForm>
    );
  }  
}

const mapStateToProps = ((state) => {
  return {isVisibleLoading: state.ui.isVisibleLoading,
          proformas: state.ventas.proformas,
          embalajeSel: state.ventas.embalajeSel,
          clienteSel: state.clientes.clienteSel,         
          permiso: state.sesion.valoresSesionForm.Permiso,          
          idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,          
          permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
          diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias
        }
});

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ cargar_Proformas, cargar_Cliente, cargar_Embalaje, 
    generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormVen03);